var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { ref: "root", staticClass: "wkb-gene-set-prov-viz" }, [
    _vm.legendItems.length
      ? _c(
          "div",
          {
            staticClass: "wkb-gene-set-prov-viz-legend",
            attrs: { "aria-hidden": "true" },
          },
          _vm._l(_vm.legendItems, function (item) {
            return _c(
              "span",
              {
                key: item.label,
                staticClass: "wkb-gene-set-prov-viz-legend-item",
              },
              [
                _c("i", {
                  staticClass: "wkb-gene-set-prov-viz-swatch",
                  style: { background: item.color },
                }),
                _vm._v(" " + _vm._s(item.label) + " "),
              ]
            )
          }),
          0
        )
      : _vm._e(),
    _c(
      "div",
      {
        staticClass: "wkb-gene-set-prov-viz-body",
        class: { "has-detail": _vm.selectedDetail },
      },
      [
        _vm.selectedDetail
          ? _c(
              "aside",
              {
                staticClass: "wkb-gene-set-prov-viz-detail",
                attrs: { "aria-label": "Provenance item details" },
              },
              [
                _c(
                  "div",
                  { staticClass: "wkb-gene-set-prov-viz-detail-head" },
                  [
                    _c(
                      "h5",
                      { staticClass: "wkb-gene-set-prov-viz-detail-title" },
                      [_vm._v(_vm._s(_vm.selectedDetail.title))]
                    ),
                    _c(
                      "button",
                      {
                        staticClass: "wkb-gene-set-prov-viz-detail-close",
                        attrs: {
                          type: "button",
                          "aria-label": "Close details",
                        },
                        on: { click: _vm.closeDetail },
                      },
                      [_vm._v(" × ")]
                    ),
                  ]
                ),
                _c(
                  "div",
                  { staticClass: "wkb-gene-set-prov-viz-detail-body" },
                  [
                    _vm.selectedDetail.nodeType
                      ? _c(
                          "p",
                          { staticClass: "wkb-gene-set-prov-viz-detail-type" },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.selectedDetail.nodeType) + " "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm.selectedDetail.kind === "edge"
                      ? [
                          _c(
                            "dl",
                            { staticClass: "wkb-gene-set-prov-viz-detail-dl" },
                            [
                              _vm.selectedDetail.sourceName
                                ? _c("div", [
                                    _c("dt", [_vm._v("Source")]),
                                    _c("dd", [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.selectedDetail.sourceName
                                          ) +
                                          " "
                                      ),
                                      _vm.selectedDetail.sourceType
                                        ? _c(
                                            "span",
                                            {
                                              staticClass:
                                                "wkb-gene-set-prov-viz-detail-muted",
                                            },
                                            [
                                              _vm._v(
                                                " (" +
                                                  _vm._s(
                                                    _vm.selectedDetail
                                                      .sourceType
                                                  ) +
                                                  ") "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]),
                                  ])
                                : _vm._e(),
                              _vm.selectedDetail.targetName
                                ? _c("div", [
                                    _c("dt", [_vm._v("Target")]),
                                    _c("dd", [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.selectedDetail.targetName
                                          ) +
                                          " "
                                      ),
                                      _vm.selectedDetail.targetType
                                        ? _c(
                                            "span",
                                            {
                                              staticClass:
                                                "wkb-gene-set-prov-viz-detail-muted",
                                            },
                                            [
                                              _vm._v(
                                                " (" +
                                                  _vm._s(
                                                    _vm.selectedDetail
                                                      .targetType
                                                  ) +
                                                  ") "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]),
                                  ])
                                : _vm._e(),
                              _vm.selectedDetail.label
                                ? _c("div", [
                                    _c("dt", [_vm._v("Edge")]),
                                    _c("dd", [
                                      _vm._v(_vm._s(_vm.selectedDetail.label)),
                                    ]),
                                  ])
                                : _vm._e(),
                            ]
                          ),
                        ]
                      : _vm._e(),
                    _vm.selectedDetail.description
                      ? _c(
                          "p",
                          { staticClass: "wkb-gene-set-prov-viz-detail-text" },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.selectedDetail.description) + " "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm.selectedDetail.fileMeta
                      ? _c(
                          "dl",
                          { staticClass: "wkb-gene-set-prov-viz-detail-dl" },
                          [
                            _vm.selectedDetail.fileMeta.filename
                              ? _c("div", [
                                  _c("dt", [_vm._v("Filename")]),
                                  _c("dd", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.selectedDetail.fileMeta.filename
                                      )
                                    ),
                                  ]),
                                ])
                              : _vm._e(),
                            _vm.selectedDetail.fileMeta.sizeBytes != null
                              ? _c("div", [
                                  _c("dt", [_vm._v("Size")]),
                                  _c("dd", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formatFileSize(
                                          _vm.selectedDetail.fileMeta.sizeBytes
                                        )
                                      )
                                    ),
                                  ]),
                                ])
                              : _vm._e(),
                            _vm.selectedDetail.fileMeta.md5
                              ? _c("div", [
                                  _c("dt", [_vm._v("MD5")]),
                                  _c("dd", [
                                    _vm._v(
                                      _vm._s(_vm.selectedDetail.fileMeta.md5)
                                    ),
                                  ]),
                                ])
                              : _vm._e(),
                          ]
                        )
                      : _vm._e(),
                    _vm.selectedDetail.analysisCommand
                      ? _c(
                          "p",
                          {
                            staticClass: "wkb-gene-set-prov-viz-detail-command",
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "wkb-gene-set-prov-viz-detail-command-label",
                              },
                              [_vm._v("Command")]
                            ),
                            _vm._v(
                              " " +
                                _vm._s(_vm.selectedDetail.analysisCommand) +
                                " "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm.selectedDetail.httpUrl
                      ? _c(
                          "a",
                          {
                            staticClass: "wkb-gene-set-prov-viz-detail-link",
                            attrs: {
                              href: _vm.selectedDetail.httpUrl,
                              target: "_blank",
                              rel: "noopener noreferrer",
                            },
                          },
                          [_vm._v(" Open link ")]
                        )
                      : _vm._e(),
                    !_vm.hasDetailBody
                      ? _c(
                          "p",
                          { staticClass: "wkb-gene-set-prov-viz-detail-empty" },
                          [_vm._v(" No additional description available. ")]
                        )
                      : _vm._e(),
                  ],
                  2
                ),
              ]
            )
          : _vm._e(),
        _c(
          "div",
          {
            ref: "canvasWrap",
            staticClass: "wkb-gene-set-prov-viz-canvas-wrap",
          },
          [
            _c("div", {
              ref: "container",
              staticClass: "wkb-gene-set-prov-viz-canvas",
              style: { height: `${_vm.height}px` },
              attrs: { role: "img", "aria-label": _vm.ariaLabel },
            }),
            _vm.hasGraph
              ? _c(
                  "div",
                  {
                    staticClass: "wkb-gene-set-prov-viz-zoom",
                    attrs: {
                      role: "toolbar",
                      "aria-label": "Provenance graph zoom",
                    },
                  },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.number",
                          value: _vm.zoomLevel,
                          expression: "zoomLevel",
                          modifiers: { number: true },
                        },
                      ],
                      staticClass: "wkb-gene-set-prov-viz-zoom-slider",
                      attrs: {
                        type: "range",
                        min: _vm.zoomMin,
                        max: _vm.zoomMax,
                        step: _vm.zoomStep,
                        "aria-label": "Provenance graph zoom",
                      },
                      domProps: { value: _vm.zoomLevel },
                      on: {
                        input: _vm.onZoomInput,
                        __r: function ($event) {
                          _vm.zoomLevel = _vm._n($event.target.value)
                        },
                        blur: function ($event) {
                          return _vm.$forceUpdate()
                        },
                      },
                    }),
                    _c(
                      "button",
                      {
                        staticClass:
                          "wkb-gene-set-prov-viz-zoom-btn wkb-gene-set-prov-viz-zoom-btn--fit",
                        attrs: {
                          type: "button",
                          title: "Fit graph",
                          "aria-label": "Fit graph",
                        },
                        on: { click: _vm.fitNetworkView },
                      },
                      [_vm._v(" Fit ")]
                    ),
                  ]
                )
              : _vm._e(),
          ]
        ),
      ]
    ),
    _vm.hoverTooltip.visible
      ? _c(
          "div",
          {
            staticClass: "wkb-gene-set-prov-viz-tooltip",
            style: _vm.tooltipStyle,
            attrs: { role: "button", tabindex: "0" },
            on: {
              click: function ($event) {
                $event.stopPropagation()
                return _vm.onTooltipClick.apply(null, arguments)
              },
              keydown: [
                function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  )
                    return null
                  $event.preventDefault()
                  return _vm.onTooltipClick.apply(null, arguments)
                },
                function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "space", 32, $event.key, [
                      " ",
                      "Spacebar",
                    ])
                  )
                    return null
                  $event.preventDefault()
                  return _vm.onTooltipClick.apply(null, arguments)
                },
              ],
            },
          },
          [
            _c("span", { staticClass: "wkb-gene-set-prov-viz-tooltip-label" }, [
              _vm._v(_vm._s(_vm.hoverTooltip.text)),
            ]),
            _c("span", { staticClass: "wkb-gene-set-prov-viz-tooltip-hint" }, [
              _vm._v("Click for details"),
            ]),
          ]
        )
      : _vm._e(),
    !_vm.hasGraph
      ? _c("p", { staticClass: "wkb-gene-set-prov-viz-empty" }, [
          _vm._v("No provenance graph data available."),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }